import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";

function Footer() {
    return (
        <footer class="footer footer-center p-10 rounded font-quicksand pt-10" data-theme="weireframe">
            <div>
                <div className="grid grid-flow-col gap-2">
                    <div className="grid grid-flow-col gap-2">
                        <a href="https://www.facebook.com/willowclothingmm">Facebook |</a>
                        <a href="https://instagram.com/willowclothingmm?igshid=YmMyMTA2M2Y=">Instagram |</a>
                        <a href="https://willowlabelmm.com/">Youtube |</a>
                    </div>
                    <a href="https://willowlabelmm.com/terms" className="link link-hover" >Terms & Conditions |</a>
                    <Link to={paths.contact} className="link link-hover" >Contact</Link>
                </div>
                <div className="pt-8">
                    <p>Copyright © {(new Date().getFullYear())} - All right reserved by Willow Clothing Brand.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;